var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import Dropdown from "../Dropdown";
import Link from "../Link";
import AppleIcon from "../Icons/Brand/Apple";
import CancelCircleIcon from "../Icons/CancelCircle";
import GoogleIcon from "../Icons/Brand/Google";
import Office365Icon from "../Icons/Brand/Office365";
import OutlookIcon from "../Icons/Brand/Outlook";
import YahooIcon from "../Icons/Brand/Yahoo";
import { ButtonTypesPropTypes, ButtonTypes } from "../Button/ButtonPropTypes";
import { createGoogleCalendarUrl, createOutlookLiveCalendarUrl, createYahooCalendarUrl, createICSCalendarUrl, createOutlookOfficeCalendarUrl, } from "./helpers";
import { CalendarProviderPropTypes, CALENDAR_PROVIDERS } from "./AddToCalendarPropTypes";
const getProviderItem = (provider, props, iconProps) => {
    if (provider === CALENDAR_PROVIDERS.google) {
        return {
            linkProps: {
                href: createGoogleCalendarUrl(props),
                "aria-label": "Add event to Google calendar",
            },
            label: "Google",
            icon: React.createElement(GoogleIcon, Object.assign({}, iconProps)),
        };
    }
    if (provider === CALENDAR_PROVIDERS.office365) {
        return {
            linkProps: {
                href: createOutlookOfficeCalendarUrl(props),
                "aria-label": "Add event to Office 365",
            },
            label: "Office 365",
            icon: React.createElement(Office365Icon, Object.assign({}, iconProps)),
        };
    }
    if (provider === CALENDAR_PROVIDERS.outlookLive) {
        return {
            linkProps: {
                href: createOutlookLiveCalendarUrl(props),
                "aria-label": "Add event to Outlook calendar",
            },
            label: "Outlook",
            icon: React.createElement(OutlookIcon, Object.assign({}, iconProps)),
        };
    }
    if (provider === CALENDAR_PROVIDERS.yahoo) {
        return {
            linkProps: {
                href: createYahooCalendarUrl(props),
                "aria-label": "Add event to Yahoo calendar",
            },
            label: "Yahoo",
            icon: React.createElement(YahooIcon, Object.assign({}, iconProps)),
        };
    }
    if (provider === CALENDAR_PROVIDERS.apple) {
        return {
            linkProps: {
                href: createICSCalendarUrl(props),
                "aria-label": "Add event to Apple calendar",
                download: "calendar-event",
            },
            label: "Apple",
            icon: React.createElement(AppleIcon, Object.assign({}, iconProps)),
        };
    }
    return null;
};
const AddToCalendar = (_a) => {
    var { buttonLabel, buttonType, color, withIcon, className, calendarProviders } = _a, props = __rest(_a, ["buttonLabel", "buttonType", "color", "withIcon", "className", "calendarProviders"]);
    const iconProps = {
        size: "medium",
    };
    const calendarItems = calendarProviders.map((provider) => getProviderItem(provider, props, iconProps));
    return (React.createElement(Dropdown, { className: className, trigger: "click", overlay: React.createElement("ul", { className: "gerudo-add-to-calendar" }, calendarItems.map((calendarItem, i) => (React.createElement("li", { key: i },
            React.createElement(Link, Object.assign({}, calendarItem.linkProps, { target: "_blank" }),
                calendarItem.icon,
                calendarItem.label))))) },
        React.createElement(Button, { type: buttonType, icon: withIcon && React.createElement(CancelCircleIcon, { key: "Add", color: color, rotate: 45, title: "add to calendar icon" }) }, buttonLabel)));
};
AddToCalendar.defaultProps = {
    title: "Sample Event",
    description: "This is the sample event provided as an example only",
    location: "Quebec, QC",
    startTime: "2021-03-16T20:15:00-04:00",
    endTime: "2021-03-16T21:45:00-04:00",
    buttonLabel: "Add to calendar",
    buttonType: ButtonTypes.Secondary,
    withIcon: true,
    calendarProviders: Object.values(CALENDAR_PROVIDERS),
};
AddToCalendar.propTypes = {
    description: PropTypes.string,
    endTime: PropTypes.string,
    location: PropTypes.string,
    startTime: PropTypes.string,
    title: PropTypes.string,
    buttonLabel: PropTypes.node,
    buttonType: ButtonTypesPropTypes,
    withIcon: PropTypes.bool,
    calendarProviders: PropTypes.arrayOf(CalendarProviderPropTypes),
};
export default AddToCalendar;
export { AddToCalendar };
//# sourceMappingURL=index.js.map